
export class ChargedRemote  {
    id: number;
    districtIds: number[];    
}